export default {
  brand: {
    name: "Basetao Sheet",
    tagline: "Le centre de ressources Basetao",
  },
  nav: {
    spreadsheet: "Tableur",
    reviews: "Avis",
    shipping: "Livraison",
    coupons: "Bons",
    warehouse: "Entrepôt",
    qc: "QC",
    guides: "Guides",
    safety: "Sécurité",
    cta: "Explorer le tableur",
    home: "Accueil",
    shoppingGuide: "Guide d'achat",
  },
  lang: {
    label: "Langue",
    en: "English",
    fr: "Français",
    de: "Deutsch",
    es: "Español",
    pt: "Português",
  },
  categories: {
    title: "Acheter par catégorie",
    dropdownLabel: "Parcourir les catégories",
    browseCta: "Voir toutes les catégories",
    shoes: "Chaussures",
    hoodies: "Sweats à capuche / Pulls",
    tshirts: "T-Shirts",
    jackets: "Vestes",
    pants: "Pantalons / Shorts",
    headwear: "Couvre-chefs",
    sets: "Ensembles",
    underwear: "Sous-vêtements / Caleçons",
    jersey: "Maillot",
    accessories: "Accessoires",
    bags: "Sacs",
    belts: "Ceintures",
    perfumes: "Parfums",
    other: "Autres articles",
  },
  hero: {
    eyebrow: "LE CENTRE DE RESSOURCES BASETAO",
    title: "Basetao Spreadsheet — Trouvez produits, vendeurs, QC et livraison plus vite",
    subtitle:
      "Explorez le Basetao Spreadsheet : ressources produits organisées, guides vendeurs, infos QC, guides de livraison, conseils entrepôt, avis et ressources d'achat pratiques — tout au même endroit.",
    primaryCta: "Basetao Spreadsheet",
    secondaryCta: "Acheter maintenant",
    trust: "Ressource indépendante • Mise à jour régulière • Adaptée aux débutants",
  },
  what: {
    title: "Qu'est-ce qu'un Basetao Spreadsheet ?",
    subtitle:
      "Un Basetao Spreadsheet est une façon structurée d'organiser et de découvrir les infos produits, les vendeurs, les liens et les ressources d'achat. Il rend la recherche de produits plus rapide et plus facile à naviguer.",
    card1Title: "Trouver des produits",
    card1Desc: "Découvrez des ressources produits organisées.",
    card2Title: "Étudier les vendeurs",
    card2Desc: "Consultez les infos vendeurs en un coup d'œil.",
    card3Title: "Vérifier le QC",
    card3Desc: "Comprenez les détails du contrôle qualité.",
    card4Title: "Comparer la livraison",
    card4Desc: "Comprenez clairement les variables de livraison.",
    cta: "Explorer le Basetao Spreadsheet",
  },
  popular: {
    title: "Recherches populaires",
    subtitle: "Les sujets les plus recherchés par les acheteurs Basetao.",
    items: [
      "Basetao Spreadsheet",
      "Avis Basetao",
      "Frais de livraison Basetao",
      "Code promo Basetao",
      "Code de réduction Basetao",
      "Entrepôt Basetao",
      "Basetao est-il fiable ?",
      "QC Basetao",
    ],
  },
  why: {
    title: "Pourquoi utiliser ce site ?",
    subtitle: "Conçu pour rendre votre recherche Basetao plus claire et plus rapide.",
    items: [
      { title: "Organisé", desc: "Tout est structuré au même endroit." },
      { title: "Pratique", desc: "Axé sur de vraies décisions d'achat." },
      { title: "Transparent", desc: "Nous expliquons ouvertement les limites et incertitudes." },
      { title: "Multilingue", desc: "Disponible en cinq langues." },
    ],
  },
  how: {
    title: "Comment ça marche",
    subtitle: "Un parcours de recherche simple, de la découverte au paiement.",
    steps: [
      { title: "Trouver", desc: "Parcourez les ressources produits et vendeurs." },
      { title: "Étudier", desc: "Consultez les annonces, vendeurs et liens." },
      { title: "Comparer", desc: "Pesez QC, livraison et prix." },
      { title: "Vérifier", desc: "Consultez les notes de sécurité et signaux d'alerte." },
      { title: "Continuer", desc: "Rendez-vous sur le site principal pour acheter." },
    ],
  },
  safety: {
    title: "Note de sécurité importante",
    text:
      "Les annonces, vendeurs, frais de livraison et promotions peuvent changer. Les guides et tableurs organisent l'information mais ne peuvent garantir la qualité des produits, la fiabilité des vendeurs ni les résultats de livraison.",
    links: [
      "Sécurité des vendeurs",
      "Guide QC",
      "Risques de livraison",
      "Sécurité du paiement",
      "Basetao est-il fiable ?",
    ],
  },
  faq: {
    title: "Questions fréquentes",
    items: [
      {
        q: "Qu'est-ce qu'un Basetao Spreadsheet ?",
        a: "C'est un document structuré qui organise produits, vendeurs, prix, photos QC et détails de livraison au même endroit, pour une recherche plus facile.",
      },
      {
        q: "Comment fonctionne un Basetao Spreadsheet ?",
        a: "Il regroupe les infos utiles en colonnes et catégories, pour trouver, comparer et suivre les articles plus vite qu'en parcourant des messages éparpillés.",
      },
      {
        q: "Basetao est-il fiable ?",
        a: "Basetao est un agent d'achat utilisé depuis longtemps par de nombreux acheteurs internationaux. Ce site est indépendant : vérifiez toujours vous-même vendeurs et commandes.",
      },
      {
        q: "Combien coûte la livraison Basetao ?",
        a: "Le coût dépend du poids, des dimensions, de la destination, de la méthode et de l'assurance. Consultez le guide de livraison du site principal pour les tarifs actuels.",
      },
      {
        q: "Où trouver des codes promo Basetao ?",
        a: "Les promotions changent souvent. Cherchez des offres vérifiées et actuelles plutôt que des codes expirés trouvés ailleurs.",
      },
    ],
  },
  finalCta: {
    title: "Prêt à explorer le Basetao Spreadsheet ?",
    subtitle: "Parcourez produits, vendeurs et ressources organisés sur le site principal.",
    button: "Explorer le Basetao Spreadsheet",
  },
  guides: {
    title: "Guides et ressources Basetao",
    subtitle:
      "Des articles de fond couvrant le tableur, les avis, la livraison, les coupons, l'entrepôt et la sécurité.",
    readMore: "Lire l'article",
  },
  footer: {
    description:
      "Une ressource d'information indépendante sur le Basetao Spreadsheet. Non affilié à Basetao ni approuvé par celui-ci.",
    resources: "Ressources",
    about: "À propos",
    contact: "Contact",
    privacy: "Confidentialité",
    terms: "Conditions",
    disclaimer: "Avertissement",
    cookie: "Politique des cookies",
    languages: "Langues",
    copyright: "© 2026 Basetao Sheet. Tous droits réservés.",
  },
  article: {
    breadcrumb: "Accueil › Guides",
    h1: "Basetao Spreadsheet : le guide complet produits, vendeurs, QC et livraison",
    updated: "Dernière mise à jour : 19 août 2026",
    quickAnswerLabel: "Réponse rapide",
    quickAnswer:
      "Un Basetao Spreadsheet est un document structuré et partagé qui organise produits, vendeurs, prix, photos QC et détails de livraison au même endroit. Il vous aide à trouver des articles plus vite, comparer les vendeurs et suivre les commandes — bien plus simple que de parcourir des messages éparpillés.",
    tocTitle: "Sommaire",
    sections: [
      {
        title: "Qu'est-ce qu'un Basetao Spreadsheet ?",
        body: [
          "Un Basetao Spreadsheet est essentiellement un tableau partagé qui rassemble tout ce dont un acheteur a besoin pour étudier un achat. Au lieu de fouiller l'historique de chat, les albums vendeurs ou les favoris, vous retrouvez noms de produits, images, détails vendeurs, prix, statut QC et notes de livraison dans des colonnes claires.",
          "Cette organisation est particulièrement utile quand vous comparez beaucoup d'articles à la fois. Le tableur sert de source unique que vous pouvez parcourir rapidement, ce qui fait gagner du temps et réduit le risque de confondre des produits similaires de vendeurs différents.",
        ],
      },
      {
        title: "Pourquoi les acheteurs utilisent un Basetao Spreadsheet",
        body: [
          "La raison principale est la rapidité. Quand la recherche est structurée, vous passez moins de temps à chercher et plus à décider. Un tableur garde aussi une trace de ce que vous avez trouvé, commandé et de ce qu'il reste à vérifier.",
          "Pour les grosses commandes ou les achats répétés, un tableur vous aide à rester cohérent. Vous suivez les vendeurs de confiance, notez les articles qui ont passé le QC et gardez en mémoire les choix de livraison qui ont bien fonctionné.",
        ],
      },
      {
        title: "Comment un Basetao Spreadsheet est organisé",
        body: [
          "Un tableur type regroupe l'information en quelques colonnes principales : nom du produit, image, catégorie, vendeur, prix, statut QC et un lien vers l'article. Certains incluent aussi le poids de livraison, les notes d'entrepôt et des remarques personnelles.",
          "Les catégories reprennent généralement la structure de la boutique — chaussures, sweats, t-shirts, vestes, pantalons, couvre-chefs, ensembles, sous-vêtements, maillots, accessoires, sacs, ceintures, parfums et autres articles. Cela permet d'aller directement à la section qui vous intéresse.",
        ],
      },
      {
        title: "Comment trouver des produits avec un Basetao Spreadsheet",
        body: [
          "Commencez par la catégorie qui vous intéresse, puis parcourez les noms et images à la recherche d'articles correspondants. Utilisez les colonnes vendeur et prix pour affiner vos options.",
          "Dès que vous repérez un article prometteur, ouvrez son lien sur le site principal pour voir les détails complets, la disponibilité et les offres actuelles. Le tableur est un point de départ — c'est l'annonce elle-même qui confirme les spécificités.",
        ],
      },
      {
        title: "Comment étudier les vendeurs",
        body: [
          "L'étude des vendeurs compte car la qualité et la fiabilité varient. Regardez si un vendeur apparaît régulièrement, comment ses produits sont décrits et si les notes QC passées signalent des problèmes récurrents.",
          "Traitez l'information vendeur comme un premier signal, pas une garantie. Les conditions changent : revérifiez chaque vendeur à chaque commande, surtout pour les articles coûteux.",
        ],
      },
      {
        title: "Comprendre les photos QC",
        body: [
          "Les photos QC (contrôle qualité) sont l'un des éléments les plus précieux du processus d'achat. Elles montrent l'article réel avant l'expédition, pour détecter tôt les problèmes de taille, de couleur ou de défaut.",
          "En examinant les photos QC, comparez-les à l'annonce d'origine. Regardez les coutures, logos, couleurs et mesures. Si quelque chose semble anormal, posez des questions avant l'expédition.",
        ],
      },
      {
        title: "Frais et options de livraison",
        body: [
          "Le coût de livraison n'est pas un chiffre fixe — il dépend du poids du colis, des dimensions, du pays de destination, de la méthode choisie et de l'assurance éventuelle. Les colis plus lourds ou volumineux coûtent généralement plus cher.",
          "Différentes lignes de livraison équilibrent rapidité et prix. Certaines sont plus rapides mais plus chères, d'autres moins chères mais plus lentes. Le bon choix dépend de la rapidité souhaitée et de votre budget.",
        ],
      },
      {
        title: "Erreurs courantes à éviter",
        body: [
          "Une erreur fréquente est de commander avant de vérifier les photos QC, ce qui complique la résolution des problèmes. Une autre est d'ignorer le poids lors de la planification de la livraison, ce qui peut gonfler la facture.",
          "Il est aussi facile de confondre des articles similaires de vendeurs différents. Utiliser le tableur pour noter quel article vient de quel vendeur évite la confusion et garde vos commandes organisées.",
        ],
      },
      {
        title: "Sécurité et signaux d'alerte",
        body: [
          "Gardez une saine prudence. Méfiez-vous des vendeurs sans historique, des prix trop beaux pour être vrais ou des annonces réutilisant des photos sans rapport. Les petits dépôts ou demandes de paiement inhabituelles peuvent aussi être des signaux d'alerte.",
          "Ce site est une ressource indépendante : vérifiez toujours l'information vous-même. Aucun guide ne peut garantir la qualité des produits, la fiabilité des vendeurs ni les résultats de livraison — utilisez ces ressources comme un point de départ utile, pas comme un substitut à votre propre jugement.",
        ],
      },
    ],
    tableTitle: "Tableur vs notes dispersées",
    tableHeaders: ["Fonctionnalité", "Basetao Spreadsheet", "Notes manuelles"],
    tableRows: [
      ["Découverte produits", "Organisée et filtrable", "Difficile à chercher"],
      ["Étude vendeurs", "Colonnes structurées", "Messages éparpillés"],
      ["Suivi QC", "Champs QC dédiés", "Mélangé au chat"],
      ["Planification livraison", "Claire d'un coup d'œil", "Nécessite de creuser"],
      ["Idéal pour", "Chercheurs sérieux", "Navigation occasionnelle"],
    ],
    faqTitle: "Questions fréquentes",
    faqs: [
      {
        q: "Un Basetao Spreadsheet est-il gratuit ?",
        a: "Les tableurs sont généralement des ressources partagées. Consultez le site principal pour la version actuelle et les détails d'accès.",
      },
      {
        q: "À quelle fréquence le tableur est-il mis à jour ?",
        a: "Les mises à jour varient. Annonces, vendeurs et prix changent : traitez l'information comme un instantané et confirmez les détails sur le site principal avant de commander.",
      },
      {
        q: "Puis-je utiliser le tableur sur mon téléphone ?",
        a: "La plupart des documents structurés fonctionnent sur ordinateur comme sur mobile. La mise en page est souvent plus confortable sur grand écran pour comparer beaucoup de colonnes.",
      },
      {
        q: "Le tableur garantit-il la qualité des produits ?",
        a: "Non. Il organise l'information mais ne peut garantir qualité, fiabilité des vendeurs ni résultats de livraison. Vérifiez toujours les photos QC et faites vos propres contrôles.",
      },
    ],
    conclusion:
      "Un Basetao Spreadsheet est un outil pratique pour quiconque veut étudier produits, vendeurs, QC et livraison plus efficacement. Il rassemble des informations dispersées en une vue claire, pour de meilleures décisions et moins de temps perdu à chercher. N'oubliez pas que les détails changent : utilisez le tableur comme un guide et confirmez toujours les dernières informations sur le site principal avant d'acheter.",
    relatedTitle: "Ressources liées",
    backHome: "Retour à l'accueil",
    ctaLabel: "Explorer le Basetao Spreadsheet",
    conclusionTitle: "Conclusion",
    readGuide: "Lire le guide",
    toc: [
      "Qu'est-ce qu'un Basetao Spreadsheet ?",
      "Pourquoi les acheteurs utilisent un Basetao Spreadsheet",
      "Comment un Basetao Spreadsheet est organisé",
      "Comment trouver des produits",
      "Comment étudier les vendeurs",
      "Comprendre les photos QC",
      "Frais et options de livraison",
      "Erreurs courantes à éviter",
      "Sécurité et signaux d'alerte",
    ],
  },
};